/**
 * Smart Phone Number Validation
 * Automatically formats and validates phone numbers based on selected country
 */

var phoneValidationSystem = {
    // Country phone formats and patterns
    phoneFormats: {
        'DE': {
            pattern: /^(\+49|0049|0)?[\s\-]?(\d{3,4})[\s\-]?(\d{3,8})$/,
            format: '+49 $2 $3',
            placeholder: '+49 30 12345678',
            maxLength: 17
        },
        'AT': {
            pattern: /^(\+43|0043|0)?[\s\-]?(\d{3,4})[\s\-]?(\d{3,8})$/,
            format: '+43 $2 $3',
            placeholder: '+43 1 1234567',
            maxLength: 16
        },
        'CH': {
            pattern: /^(\+41|0041|0)?[\s\-]?(\d{2})[\s\-]?(\d{3})[\s\-]?(\d{2})[\s\-]?(\d{2})$/,
            format: '+41 $2 $3 $4 $5',
            placeholder: '+41 44 123 45 67',
            maxLength: 17
        },
        'FR': {
            pattern: /^(\+33|0033|0)?[\s\-]?(\d{1})[\s\-]?(\d{2})[\s\-]?(\d{2})[\s\-]?(\d{2})[\s\-]?(\d{2})$/,
            format: '+33 $2 $3 $4 $5 $6',
            placeholder: '+33 1 23 45 67 89',
            maxLength: 18
        },
        'IT': {
            pattern: /^(\+39|0039)?[\s\-]?(\d{3})[\s\-]?(\d{3,4})[\s\-]?(\d{3,4})$/,
            format: '+39 $2 $3 $4',
            placeholder: '+39 06 1234 5678',
            maxLength: 17
        },
        'NL': {
            pattern: /^(\+31|0031|0)?[\s\-]?(\d{2})[\s\-]?(\d{3,4})[\s\-]?(\d{4})$/,
            format: '+31 $2 $3 $4',
            placeholder: '+31 20 123 4567',
            maxLength: 16
        },
        'BE': {
            pattern: /^(\+32|0032|0)?[\s\-]?(\d{1})[\s\-]?(\d{3})[\s\-]?(\d{2})[\s\-]?(\d{2})$/,
            format: '+32 $2 $3 $4 $5',
            placeholder: '+32 2 123 45 67',
            maxLength: 16
        },
        'ES': {
            pattern: /^(\+34|0034)?[\s\-]?(\d{3})[\s\-]?(\d{3})[\s\-]?(\d{3})$/,
            format: '+34 $2 $3 $4',
            placeholder: '+34 91 123 4567',
            maxLength: 16
        },
        // Default for other countries
        'default': {
            pattern: /^(\+\d{1,3})?[\s\-]?(\d{1,4})[\s\-]?(\d{1,4})[\s\-]?(\d{1,8})$/,
            format: '$1 $2 $3 $4',
            placeholder: '+1 234 567 8900',
            maxLength: 20
        }
    },

    init: function() {
        
        var self = this;
        var $ = jQuery;
        
        // Initialize phone fields
        this.initPhoneFields();
        
        // Listen for country changes
        $(document.body).on('change', 'input[name*="_country"], select[name*="_country"]', function() {
            setTimeout(function() {
                self.initPhoneFields();
            }, 100);
        });
        
        // Re-initialize after checkout updates
        $(document.body).on('updated_checkout', function() {
            setTimeout(function() {
                self.initPhoneFields();
            }, 200);
        });
        
        // DEBUG: ✅ Smart Phone Validation initialized;
    },

    initPhoneFields: function() {
        var self = this;
        var $ = jQuery;
        
        // Find all phone fields
        $('input[name*="_phone"]').each(function() {
            var $phoneField = $(this);
            var fieldName = $phoneField.attr('name');
            var isShipping = fieldName.includes('shipping');
            var isBilling = fieldName.includes('billing');
            
            // Get corresponding country field
            var countryFieldName = '';
            if (isShipping) {
                countryFieldName = 'shipping_country';
            } else if (isBilling) {
                countryFieldName = 'billing_country';
            }
            
            var selectedCountry = self.getSelectedCountry(countryFieldName);
            
            
            self.setupPhoneField($phoneField, selectedCountry);
        });
    },

    getSelectedCountry: function(countryFieldName) {
        var $ = jQuery;
        var country = 'DE'; // Default to Germany
        
        // Try to get from hidden field (autocomplete)
        var $hiddenCountry = $('#' + countryFieldName);
        if ($hiddenCountry.length && $hiddenCountry.val()) {
            country = $hiddenCountry.val();
        } else {
            // Try to get from select field
            var $selectCountry = $('select[name="' + countryFieldName + '"]');
            if ($selectCountry.length && $selectCountry.val()) {
                country = $selectCountry.val();
            }
        }
        
        return country;
    },

    setupPhoneField: function($phoneField, country) {
        var self = this;
        var $ = jQuery;
        
        // Remove existing handlers and indicators
        $phoneField.off('input.phoneValidation keyup.phoneValidation blur.phoneValidation focus.phoneValidation');
        
        var $wrapper = $phoneField.closest('.form-row');
        $wrapper.find('.phone-country-indicator, .phone-helper-text').remove();
        
        // Add intelligent helper text instead of country flag
        var helperText = this.getPhoneHelperText(country);
        $phoneField.after('<div class="phone-helper-text">' + helperText + '</div>');
        
        // Set placeholder with example
        var phoneFormat = this.phoneFormats[country] || this.phoneFormats['default'];
        $phoneField.attr('placeholder', 'z.B. ' + phoneFormat.placeholder);
        $phoneField.attr('maxlength', phoneFormat.maxLength);
        
        // Show helper on focus
        $phoneField.on('focus.phoneValidation', function() {
            $wrapper.find('.phone-helper-text').addClass('active');
        });
        
        // Validate on blur without auto-formatting
        $phoneField.on('blur.phoneValidation', function() {
            var $formRow = $(this).closest('.form-row');
            var value = $(this).val().trim();
            
            $wrapper.find('.phone-helper-text').removeClass('active');
            
            if (!value) {
                $formRow.removeClass('woocommerce-invalid woocommerce-validated');
                self.hidePhoneError($formRow);
                return;
            }
            
            var validation = self.validatePhoneNumberSmart(value);
            
            if (validation.valid) {
                $formRow.addClass('woocommerce-validated').removeClass('woocommerce-invalid');
                self.hidePhoneError($formRow);
            } else {
                $formRow.addClass('woocommerce-invalid').removeClass('woocommerce-validated');
                self.showPhoneErrorSmart($formRow, validation.message, validation.example);
            }
        });
    },

    formatPhoneNumber: function(value, phoneFormat) {
        // Remove all non-digits except +
        var cleaned = value.replace(/[^\d+]/g, '');
        
        // Apply country-specific formatting
        if (phoneFormat.pattern.test(cleaned)) {
            return cleaned.replace(phoneFormat.pattern, phoneFormat.format);
        }
        
        return cleaned;
    },

    validatePhoneNumber: function(value, phoneFormat) {
        if (!value) return true; // Empty is valid (optional field)
        
        var cleaned = value.replace(/[^\d+]/g, '');
        return phoneFormat.pattern.test(cleaned);
    },

    getPhoneHelperText: function(country) {
        var texts = {
            'DE': '🇩🇪 Für Deutschland: +49 oder 0 am Anfang',
            'AT': '🇦🇹 Für Österreich: +43 oder 0 am Anfang', 
            'CH': '🇨🇭 Für Schweiz: +41 oder 0 am Anfang',
            'IT': '🇮🇹 Für Italien: +39 (ohne 0 weglassen)',
            'FR': '🇫🇷 Für Frankreich: +33 oder 0 am Anfang',
            'ES': '🇪🇸 Für Spanien: +34',
            'NL': '🇳🇱 Für Niederlande: +31 oder 0 am Anfang',
            'BE': '🇧🇪 Für Belgien: +32 oder 0 am Anfang'
        };
        
        return texts[country] || '📞 Mit Ländervorwahl (+49, +43, +41, etc.)';
    },
    
    validatePhoneNumberSmart: function(value) {
        // Remove spaces and dashes for validation
        var cleaned = value.replace(/[\s\-]/g, '');
        
        // Check if it starts with + (international)
        if (cleaned.startsWith('+')) {
            if (cleaned.length >= 8 && cleaned.length <= 20) {
                return { valid: true };
            } else {
                return { 
                    valid: false, 
                    message: 'Internationale Nummer zu kurz oder zu lang',
                    example: '+49 30 12345678'
                };
            }
        }
        
        // Check if it starts with 0 (national)
        if (cleaned.startsWith('0')) {
            if (cleaned.length >= 6 && cleaned.length <= 15) {
                return { valid: true };
            } else {
                return { 
                    valid: false, 
                    message: 'Nationale Nummer ungültig',
                    example: '030 12345678'
                };
            }
        }
        
        // Check if it's just digits (mobile without 0)
        if (/^\d+$/.test(cleaned)) {
            if (cleaned.length >= 6 && cleaned.length <= 15) {
                return { valid: true };
            } else {
                return { 
                    valid: false, 
                    message: 'Telefonnummer zu kurz oder zu lang',
                    example: '0176 12345678'
                };
            }
        }
        
        return { 
            valid: false, 
            message: 'Ungültiges Format',
            example: '+49 30 12345678 oder 030 12345678'
        };
    },

    showPhoneErrorSmart: function($formRow, message, example) {
        var $ = jQuery;
        var $errorMsg = $formRow.find('.phone-validation-error');
        
        if ($errorMsg.length === 0) {
            var errorHtml = '<div class="phone-validation-error">📞 ' + message + (example ? '<br><small>Beispiel: ' + example + '</small>' : '') + '</div>';
            $formRow.append(errorHtml);
        } else {
            $errorMsg.html('📞 ' + message + (example ? '<br><small>Beispiel: ' + example + '</small>' : ''));
        }
    },

    hidePhoneError: function($formRow) {
        $formRow.find('.phone-validation-error').remove();
    }
};

// Auto-initialize when document is ready
jQuery(document).ready(function($) {
    // Wait for other systems to load
    setTimeout(function() {
        phoneValidationSystem.init();
    }, 2000);
});